module.exports = __webpack_public_path__ + "img/img-3.ab19ba5.webp";